import {
    enabledLanguages,
    localizationData,
    defaultLanguage,
} from '../../../Intl/setup';
import { SWITCH_LANGUAGE } from './IntlActions';

const navigatorLanguage = (((global.navigator || {}).language) || '').split('-')[0];
const initLocale = enabledLanguages.includes(navigatorLanguage) ? navigatorLanguage : defaultLanguage;

const initialState = {
    isInit: false,
    locale: initLocale,
    enabledLanguages,
    ...(localizationData[initLocale] || {}).messages,
};

const IntlReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SWITCH_LANGUAGE: {
            const { type, ...data } = action; // eslint-disable-line
            return { ...state, ...data };
        }

        default:
            return state;
    }
};

export default IntlReducer;
